import { render, staticRenderFns } from "./AccountCloseModal.vue?vue&type=template&id=9bdefdb8&scoped=true"
import script from "./AccountCloseModal.vue?vue&type=script&lang=js"
export * from "./AccountCloseModal.vue?vue&type=script&lang=js"
import style0 from "./AccountCloseModal.vue?vue&type=style&index=0&id=9bdefdb8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9bdefdb8",
  null
  
)

export default component.exports